import React from 'react';
import { Modal } from 'react-bootstrap';
import CommentPopUp from './CommentPopUp';

class IncompleteCommentPopUp extends React.Component {
    render() {
        return (
            <CommentPopUp
                header={<Modal.Title>Incomplete Step&nbsp;</Modal.Title>}
                formLabel={<React.Fragment>Enter the reason for the incomplete status</React.Fragment>}
                commentTypeCode="INC"
                {...this.props} />
        )
    }
}

export default IncompleteCommentPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/IncompleteCommentPopUp.js